import React from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'components/shared/generic/accordion/presentational/Accordion';
import { getTheme } from '../../../../../selectors/darkMode';
import clsx from 'clsx';

const ZendeskFAQs = ({ faqs }) => {
    const isDarkModeEnabled = useSelector(getTheme);

    return (
        <div
            className={clsx('zendesk-faqs', {
                'dark-mode': isDarkModeEnabled,
            })}
        >
            {faqs.map(({ title, body }, index) => (
                <Accordion key={index} title={title} tracking>
                    {<div dangerouslySetInnerHTML={{ __html: body }}></div>}
                </Accordion>
            ))}
        </div>
    );
};

export default ZendeskFAQs;
